import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot,
  faMoneyBill1,
  faHeart,
  faCalendarAlt,
} from "@fortawesome/free-solid-svg-icons";
import React, { useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

const TopVakanciesSearch = () => {
  const { t } = useTranslation();
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);

  const slidesData = Array(11).fill({
    img: "",
    vacancy: "Vacancy name",
    company: "Company name",
    location: "location",
    salary: "salary",
  });

  // Инициализация навигации после рендера
  useEffect(() => {
    if (swiperRef.current && prevRef.current && nextRef.current) {
      swiperRef.current.params.navigation.prevEl = prevRef.current;
      swiperRef.current.params.navigation.nextEl = nextRef.current;
      swiperRef.current.navigation.init();
      swiperRef.current.navigation.update();
    }
  }, []);

  return (
    <section className="w-full flex flex-col items-end gap-5">
      <h1 className="w-full translate-x-5 text-[#006674] max-sm:text-xl uppercase font-bold text-start text-3xl">
        {t("topvacansies")}
      </h1>

      <div className="relative w-full flex flex-col h-max gap-3">
        {slidesData.map((slide, index) => (
         
            <article className="w-full pt-3 overflow-hidden relative flex justify-start flex-col gap-3 items-center rounded-lg shadow-2xl shadow-slate-300 cursor-pointer bg-white">
              <div className="w-full px-3 flex justify-start items-center gap-6">
                <img
                  className="w-[80px] h-[80px] sm:w-[100px] sm:h-[100px] rounded-xl border-[4px] bg-[#bdbdbd] border-white object-contain shadow-2xl shadow-neutral-400"
                  src={slide.img}
                  alt="asasa"
                />
                <ul className="flex flex-col gap-1 items-start justify-center">
                  <li>
                    <Link
                      to="/Vacancie"
                      className="text-lg sm:text-xl text-[#006674] font-semibold"
                    >
                      {slide.vacancy}
                    </Link>
                  </li>
                  <li className="text-sm sm:text-base">{slide.company}</li>
                  <li className="flex gap-2 items-center text-sm sm:text-base">
                    <FontAwesomeIcon icon={faLocationDot} /> {slide.location}
                  </li>
                  <li className="flex gap-2 items-center text-sm sm:text-base">
                    <FontAwesomeIcon icon={faMoneyBill1} /> {slide.salary}
                  </li>
                </ul>
              </div>
              <button className="absolute right-2 top-24 rounded-full border-[2px] border-white shadow-lg shadow-neutral-500 bg-gray-400 transition-all duration-200 hover:bg-[#006674] text-white w-[35px] h-[35px]">
                <FontAwesomeIcon icon={faHeart} />
              </button>
              <div className="w-full mt-2 p-2 flex justify-between items-center bg-[#006674] text-white">
                <span>
                  <FontAwesomeIcon className="mr-1" icon={faCalendarAlt} />
                  04.09.25
                </span>
                <a href="">{t("seemore")}</a>
              </div>
            </article>
        ))}

        {/* Навигационные стрелки */}
        <div
          ref={prevRef}
          className="absolute left-0 top-1/2 -translate-y-1/2 z-10 cursor-pointer text-white text-3xl"
        >
          &#10094;
        </div>
        <div
          ref={nextRef}
          className="absolute right-0 top-1/2 -translate-y-1/2 z-10 cursor-pointer text-white text-3xl"
        >
          &#10095;
        </div>
      </div>

      {/* <Link
        className="mr-6 text-white w-max relative before:top-full before:w-0 before:transition-all before:duration-200 before:h-[2px] before:absolute before:bg-white hover:before:w-full mt-4"
        to="/top_vacancies"
      >
        {t("seemore")}
      </Link> */}
    </section>
  );
};

export default TopVakanciesSearch;
